﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    defineEmits([...useDialogPluginComponent.emits])
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

    const props = defineProps({
        data: Object
    });
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window title="Error" icon="error" size="sm">
            <template #actions>
                <q-btn flat label="Ok" color="primary" @click="onDialogOK" />
            </template>

            <tabs>
                <tab name="Message" label="Message">
                    {{data.Message}}
                </tab>
                <tab name="Details" label="Details">
                    {{data.Detail}}
                </tab>
            </tabs>
        </window>
    </q-dialog>
</template>